module.exports = __webpack_public_path__ + "static/media/heat.ae637e8e.jpg";